import Button from "./Button";
import React from "react";

interface Props {
  handleBroadcastShare: () => void;
}
export const BroadCastShare = ({ handleBroadcastShare }: Props) => {
  return (
    <Button
      label="방송 공유하기"
      className="quickBrodcastShare"
      onClick={handleBroadcastShare}
    />
  )
}